export type AuthSignInRegisterComponentResources = {
    [K in 'signInHeaderMessage' |
    'signInTextMessage' |
    'googleLoginErrorMessage' |
    'copyRightText'
    ]: string;
};

// Default values for the resources
export const DefaultAuthSignInRegisterComponentResource: AuthSignInRegisterComponentResources = {
    signInHeaderMessage: 'Sign in',
    signInTextMessage: 'Please enter your details.',
    googleLoginErrorMessage: 'Error logging into Google',
    copyRightText: '\u00A9 2025 GrapeCity India Pvt Ltd. All Rights Reserved.'
};
